"use client";

import { useQuery } from "@tanstack/react-query";

import FetchError from "./fetch-error";
import Loading from "./loading";

import api from "@/lib/api";

type StatisticsDataProps = {
  [key: string]: string | { [key: string]: string };
};

export default function StatisticsSection({
  sectionKey,
}: {
  sectionKey: string;
}) {
  const { data, error, isPending } = useQuery({
    queryKey: ["statistics", "index"],
    queryFn: () =>
      api.get<StatisticsDataProps>("/cms/statistics/index/?site_name=covid"),
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  const stats = data?.[sectionKey];
  if (!stats || Object.keys(stats).length === 0) return null;

  return (
    <div className='row g2-gray-row py-4 my-5 text-center justify-content-center'>
      {Object.entries(stats).map(([key, value], index, array) => (
        <div
          key={key}
          className='col-12 col-sm-6 col-md-3 mb-4 mb-md-0 position-relative'
        >
          <p className='lh-1 m-0'>
            <span className='display-4 g2-text-orange'>{value}</span>
            <br />
            {key.toUpperCase()}
          </p>

          {/* Vertical divider (Tablet & Up) */}
          {index < array.length - 1 && (
            <div
              className='position-absolute d-none d-md-block'
              style={{
                width: "1px",
                backgroundColor: "var(--g2-light-border)",
                top: "10%",
                bottom: "10%",
                right: 0,
              }}
            />
          )}

          {/* Horizontal divider (Mobile) */}
          {index < array.length - 1 && (
            <div
              className='w-100 d-md-none'
              style={{
                height: "1px",
                backgroundColor: "var(--g2-light-border)",
                margin: "20px 0",
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
